<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-row class="ma-0">
    <div v-if="hasItems" class="col-5">
    <v-col v-if="isDisplayed('ETABLISSEMENT_IDENTITE_ABSTRACT')" class="section_etablissement_identite_abstract">
      <div>
        <slot name="section-etablissement-identite-abstract">
          <section-etablissement-identite-abstract ref="ETABLISSEMENT_IDENTITE_ABSTRACT"
                                                   id="ETABLISSEMENT_IDENTITE_ABSTRACT"
                                                   :extended="isExtended('ETABLISSEMENT_IDENTITE_ABSTRACT')"
                                                   :showButton="true"
                                                   :autoSave="true"
                                                   :readOnly="readOnly"
                                                   :moduleId="moduleId"
                                                   :searchText="searchText"
                                                   :ressourceHeader="ressource"
                                                   :fiche="fiche"
                                                   :etablissement=selectedEtablissement
                                                   :route="route"
                                                   :attribut="attribut"
                                                   @extended="setExtended"
                                                   @fullscreen="setFullscreen"
                                                   @status="updateStatus"
                                                   @openSection="openSection"
                                                   @updated="etablissementUpdated"
                                                   @selectItem = "selectItem">
          </section-etablissement-identite-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('ETABLISSEMENT_ADRESSE_ABSTRACT')" class="section_etablissement_adresse_abstract">
      <div>
        <slot name="section-etablissement-adresse-abstract">
          <section-etablissement-adresse-abstract ref="ETABLISSEMENT_ADRESSE_ABSTRACT"
                                                  id="ETABLISSEMENT_ADRESSE_ABSTRACT"
                                                  :extended="isExtended('ETABLISSEMENT_ADRESSE_ABSTRACT')"
                                                  :showButton="true"
                                                  :autoSave="true"
                                                  :readOnly="readOnly"
                                                  :moduleId="moduleId"
                                                  :searchText="searchText"
                                                  :ressourceHeader="ressource"
                                                  :fiche="fiche"
                                                  :adresse=selectedAdresse
                                                  :etablissement=selectedEtablissement
                                                  :route="route"
                                                  :attribut="attribut"
                                                  @extended="setExtended"
                                                  @fullscreen="setFullscreen"
                                                  @status="updateStatus"
                                                  @openSection="openSection"
                                                  @updated="etablissementUpdated"
                                                  @selectItem = "selectItem">
          </section-etablissement-adresse-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('ETABLISSEMENT_REPRESENTANT_ABSTRACT')" class="section_etablissement_representant_abstract">
      <div>
        <slot name="section-etablissement-representant-abstract">
          <section-etablissement-representant-abstract ref="ETABLISSEMENT_REPRESENTANT_ABSTRACT"
                                                       id="ETABLISSEMENT_REPRESENTANT_ABSTRACT"
                                                       :extended="isExtended('ETABLISSEMENT_REPRESENTANT_ABSTRACT')"
                                                       :showButton="true"
                                                       :autoSave="true"
                                                       :readOnly="readOnly"
                                                       :moduleId="moduleId"
                                                       :searchText="searchText"
                                                       :ressourceHeader="ressource"
                                                       :fiche="fiche"
                                                       :etablissement=selectedEtablissement
                                                       :route="route"
                                                       :attribut="attribut"
                                                       @extended="setExtended"
                                                       @fullscreen="setFullscreen"
                                                       @status="updateStatus"
                                                       @openSection="openSection"
                                                       @updated="etablissementUpdated"
                                                       @selectItem = "selectItem">
          </section-etablissement-representant-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('ETABLISSEMENT_GESTIONNAIRES_ABSTRACT')" class="section_etablissement_gestionnaires_abstract">
      <div>
        <slot name="section-etablissement-gestionnaires-abstract">
          <section-etablissement-gestionnaires-abstract ref="ETABLISSEMENT_GESTIONNAIRES_ABSTRACT"
                                                        id="ETABLISSEMENT_GESTIONNAIRES_ABSTRACT"
                                                        :extended="isExtended('ETABLISSEMENT_GESTIONNAIRES_ABSTRACT')"
                                                        :showButton="true"
                                                        :autoSave="true"
                                                        :readOnly="readOnly"
                                                        :moduleId="moduleId"
                                                        :searchText="searchText"
                                                        :ressourceHeader="ressource"
                                                        :fiche="fiche"
                                                        :etablissement=selectedEtablissement
                                                        :route="route"
                                                        :attribut="attribut"
                                                        @extended="setExtended"
                                                        @fullscreen="setFullscreen"
                                                        @status="updateStatus"
                                                        @openSection="openSection"
                                                        @updated="etablissementUpdated"
                                                        @selectItem = "selectItem">
          </section-etablissement-gestionnaires-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('ETABLISSEMENT_JURIDIQUE_ABSTRACT')" class="section_etablissement_juridique_abstract">
      <div>
        <slot name="section-etablissement-juridique-abstract">
          <section-etablissement-juridique-abstract ref="ETABLISSEMENT_JURIDIQUE_ABSTRACT"
                                                    id="ETABLISSEMENT_JURIDIQUE_ABSTRACT"
                                                    :extended="isExtended('ETABLISSEMENT_JURIDIQUE_ABSTRACT')"
                                                    :showButton="true"
                                                    :autoSave="true"
                                                    :readOnly="readOnly"
                                                    :moduleId="moduleId"
                                                    :searchText="searchText"
                                                    :ressourceHeader="ressource"
                                                    :fiche="fiche"
                                                    :etablissement=selectedEtablissement
                                                    :route="route"
                                                    :attribut="attribut"
                                                    @extended="setExtended"
                                                    @fullscreen="setFullscreen"
                                                    @status="updateStatus"
                                                    @openSection="openSection"
                                                    @updated="etablissementUpdated"
                                                    @selectItem = "selectItem">
          </section-etablissement-juridique-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('DEMANDE_ATTESTATION_ABSTRACT')" class="section_demande_attestation_abstract">
      <div>
        <slot name="section-demande-attestation-abstract">
          <section-demande-attestation-abstract ref="DEMANDE_ATTESTATION_ABSTRACT"
                                                id="DEMANDE_ATTESTATION_ABSTRACT"
                                                :extended="isExtended('DEMANDE_ATTESTATION_ABSTRACT')"
                                                :showButton="true"
                                                :autoSave="true"
                                                :readOnly="readOnly"
                                                :moduleId="moduleId"
                                                :searchText="searchText"
                                                :ressourceHeader="ressource"
                                                :fiche="fiche"
                                                :etablissement=selectedEtablissement
                                                :route="route"
                                                :attribut="attribut"
                                                @extended="setExtended"
                                                @fullscreen="setFullscreen"
                                                @status="updateStatus"
                                                @openSection="openSection"
                                                @updated="etablissementUpdated"
                                                @selectItem = "selectItem">
          </section-demande-attestation-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('ETABLISSEMENT_ACCIDENT_TRAVAIL_ABSTRACT')" class="section_etablissement_accident_travail_abstract">
      <div>
        <slot name="section-etablissement-accident-travail-abstract">
          <section-etablissement-accident-travail-abstract ref="ETABLISSEMENT_ACCIDENT_TRAVAIL_ABSTRACT"
                                                           id="ETABLISSEMENT_ACCIDENT_TRAVAIL_ABSTRACT"
                                                           :extended="isExtended('ETABLISSEMENT_ACCIDENT_TRAVAIL_ABSTRACT')"
                                                           :showButton="true"
                                                           :autoSave="true"
                                                           :readOnly="readOnly"
                                                           :moduleId="moduleId"
                                                           :searchText="searchText"
                                                           :ressourceHeader="ressource"
                                                           :fiche="fiche"
                                                           :etablissement=selectedEtablissement
                                                           :route="route"
                                                           :attribut="attribut"
                                                           @extended="setExtended"
                                                           @fullscreen="setFullscreen"
                                                           @status="updateStatus"
                                                           @openSection="openSection"
                                                           @updated="etablissementUpdated"
                                                           @selectItem = "selectItem">
          </section-etablissement-accident-travail-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('ETABLISSEMENT_DOCUMENT_ABSTRACT')" class="section_etablissement_document_abstract">
      <div>
        <slot name="section-etablissement-document-abstract">
          <section-etablissement-document-abstract ref="ETABLISSEMENT_DOCUMENT_ABSTRACT"
                                                   id="ETABLISSEMENT_DOCUMENT_ABSTRACT"
                                                   :extended="isExtended('ETABLISSEMENT_DOCUMENT_ABSTRACT')"
                                                   :showButton="true"
                                                   :autoSave="true"
                                                   :readOnly="readOnly"
                                                   :moduleId="moduleId"
                                                   :searchText="searchText"
                                                   :ressourceHeader="ressource"
                                                   :fiche="fiche"
                                                   :etablissement=selectedEtablissement
                                                   :route="route"
                                                   :attribut="attribut"
                                                   @extended="setExtended"
                                                   @fullscreen="setFullscreen"
                                                   @status="updateStatus"
                                                   @openSection="openSection"
                                                   @updated="etablissementUpdated"
                                                   @selectItem = "selectItem">
          </section-etablissement-document-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('ETABLISSEMENT_PAYMENT_ABSTRACT')" class="section_etablissement_payment_abstract">
      <div>
        <slot name="section-etablissement-payment-abstract">
          <section-etablissement-payment-abstract ref="ETABLISSEMENT_PAYMENT_ABSTRACT"
                                                  id="ETABLISSEMENT_PAYMENT_ABSTRACT"
                                                  :extended="isExtended('ETABLISSEMENT_PAYMENT_ABSTRACT')"
                                                  :showButton="true"
                                                  :autoSave="true"
                                                  :readOnly="readOnly"
                                                  :moduleId="moduleId"
                                                  :searchText="searchText"
                                                  :ressourceHeader="ressource"
                                                  :fiche="fiche"
                                                  :etablissement=selectedEtablissement
                                                  :route="route"
                                                  :attribut="attribut"
                                                  @extended="setExtended"
                                                  @fullscreen="setFullscreen"
                                                  @status="updateStatus"
                                                  @openSection="openSection"
                                                  @updated="etablissementUpdated"
                                                  @selectItem = "selectItem">
          </section-etablissement-payment-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('ABONNEMENT')" class="section_abonnement">
      <div>
        <slot name="section-abonnement">
          <section-abonnement ref="ABONNEMENT"
                              id="ABONNEMENT"
                              :extended="isExtended('ABONNEMENT')"
                              :showButton="true"
                              :autoSave="true"
                              :readOnly="readOnly"
                              :moduleId="moduleId"
                              :searchText="searchText"
                              :ressourceHeader="ressource"
                              :fiche="fiche"
                              :etablissement=selectedEtablissement
                              :route="route"
                              :attribut="attribut"
                              @extended="setExtended"
                              @fullscreen="setFullscreen"
                              @status="updateStatus"
                              @openSection="openSection"
                              @updated="etablissementUpdated"
                              @selectItem = "selectItem">
          </section-abonnement>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('ETABLISSEMENT_CART_ABSTRACT')" class="section_etablissement_cart_abstract">
      <div>
        <slot name="section-etablissement-cart-abstract">
          <section-etablissement-cart-abstract ref="ETABLISSEMENT_CART_ABSTRACT"
                                               id="ETABLISSEMENT_CART_ABSTRACT"
                                               :extended="isExtended('ETABLISSEMENT_CART_ABSTRACT')"
                                               :showButton="true"
                                               :autoSave="true"
                                               :readOnly="readOnly"
                                               :moduleId="moduleId"
                                               :searchText="searchText"
                                               :ressourceHeader="ressource"
                                               :fiche="fiche"
                                               :cart=selectedCart
                                               :etablissement=selectedEtablissement
                                               :route="route"
                                               :attribut="attribut"
                                               @extended="setExtended"
                                               @fullscreen="setFullscreen"
                                               @status="updateStatus"
                                               @openSection="openSection"
                                               @updated="etablissementUpdated"
                                               @selectItem = "selectItem">
          </section-etablissement-cart-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('ETABLISSEMENT_APPRENTI_ABSTRACT')" class="section_etablissement_apprenti_abstract">
      <div>
        <slot name="section-etablissement-apprenti-abstract">
          <section-etablissement-apprenti-abstract ref="ETABLISSEMENT_APPRENTI_ABSTRACT"
                                                   id="ETABLISSEMENT_APPRENTI_ABSTRACT"
                                                   :extended="isExtended('ETABLISSEMENT_APPRENTI_ABSTRACT')"
                                                   :showButton="true"
                                                   :autoSave="true"
                                                   :readOnly="readOnly"
                                                   :moduleId="moduleId"
                                                   :searchText="searchText"
                                                   :ressourceHeader="ressource"
                                                   :fiche="fiche"
                                                   :etablissement=selectedEtablissement
                                                   :route="route"
                                                   :attribut="attribut"
                                                   @extended="setExtended"
                                                   @fullscreen="setFullscreen"
                                                   @status="updateStatus"
                                                   @openSection="openSection"
                                                   @updated="etablissementUpdated"
                                                   @selectItem = "selectItem">
          </section-etablissement-apprenti-abstract>
        </slot>
      </div>
    </v-col>
  </div>
      <v-col cols="6" v-if="!hasItems" class="empty-list-container">
        <img src="@/assets/SVG/empty-list.svg" class="empty-list-logo"/>
        <div class="empty-list-label">{{ getNewLabel() }}</div>
        <div class="pt-3" v-if="canAdd">
          <v-btn class="base"
                 :outlined="true"
                 :loading="false"
                 :block="true"
                 variant="flat"
                 @click="addItem">
            {{ addLabel }}
          </v-btn>
        </div>
      </v-col>
  </v-row>
  <Transition name="scrim">
    <div v-if="sectionOpen" class="global-scrim" @click="sectionOpen = false"></div>
  </Transition>

  <Transition name="slide-panel">
    <div v-if="sectionOpen" class="local-panel-wrap">
      <div class="local-panel col-5">
        <component :is="sectionComponent" ref="SECTION_DIALOG" v-bind="currentProperties" v-on="events"></component>
      </div>
    </div>
  </Transition>
  </div>
</template>
<script lang="ts">
import { markRaw, defineComponent,defineAsyncComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter, goToModule } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Etablissement from '@/extend/classes/Etablissement';
import Adresse from '@/extend/classes/Adresse';
import { storeAdresse } from '@/generated/stores';
import Attestation from '@/extend/classes/Attestation';
import { storeAttestation } from '@/generated/stores';
import AccidentTravail from '@/extend/classes/AccidentTravail';
import { storeAccidentTravail } from '@/generated/stores';
import Document from '@/extend/classes/Document';
import { storeDocument } from '@/generated/stores';
import Cart from '@/extend/classes/Cart';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import Owner from '@/generated/classes/Owner';
import Transaction from '@/extend/classes/Transaction';
import { storeTransaction } from '@/generated/stores';
import Apprenti from '@/extend/classes/Apprenti';
import { storeApprenti } from '@/generated/stores';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import {getSection} from "@/framework/base/helpers/ComponentFinder.ts";
import SectionEtablissementIdentiteAbstract from '@/extend/sections/SectionEtablissementIdentiteAbstractExtend.vue';
import SectionEtablissementAdresseAbstract from '@/extend/sections/SectionEtablissementAdresseAbstractExtend.vue';
import SectionEtablissementRepresentantAbstract from '@/extend/sections/SectionEtablissementRepresentantAbstractExtend.vue';
import SectionEtablissementGestionnairesAbstract from '@/extend/sections/SectionEtablissementGestionnairesAbstractExtend.vue';
import SectionEtablissementJuridiqueAbstract from '@/extend/sections/SectionEtablissementJuridiqueAbstractExtend.vue';
import SectionDemandeAttestationAbstract from '@/extend/sections/SectionDemandeAttestationAbstractExtend.vue';
import SectionEtablissementAccidentTravailAbstract from '@/extend/sections/SectionEtablissementAccidentTravailAbstractExtend.vue';
import SectionEtablissementDocumentAbstract from '@/extend/sections/SectionEtablissementDocumentAbstractExtend.vue';
import SectionEtablissementPaymentAbstract from '@/extend/sections/SectionEtablissementPaymentAbstractExtend.vue';
import SectionAbonnement from '@/custom/sections/SectionAbonnement.vue';
import SectionEtablissementCartAbstract from '@/extend/sections/SectionEtablissementCartAbstractExtend.vue';
import SectionEtablissementApprentiAbstract from '@/extend/sections/SectionEtablissementApprentiAbstractExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionEtablissementIdentiteAbstract,
    SectionEtablissementAdresseAbstract,
    SectionEtablissementRepresentantAbstract,
    SectionEtablissementGestionnairesAbstract,
    SectionEtablissementJuridiqueAbstract,
    SectionDemandeAttestationAbstract,
    SectionEtablissementAccidentTravailAbstract,
    SectionEtablissementDocumentAbstract,
    SectionEtablissementPaymentAbstract,
    SectionAbonnement,
    SectionEtablissementCartAbstract,
    SectionEtablissementApprentiAbstract,
    FicheHeader,
  },

  props: {
    etablissement: {
      type: Object as PropType<Etablissement>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
    if (this.etablissement && this.etablissement.id < 0 && this.routeElement && this.routeElement.section.component ) {
      const route = new Route();
      const component = (this.routeElement?.section.component);
      this.$nextTick(() => {
        this.openSection(component, route, false);
      });
    }
  },

  data() {
    return {
      moduleId: 0,
      sectionOpen: false,
      sectionComponent: null,
      fiche: Fiches.ETABLISSEMENT_ABSTRACT,
      sections: [
        'ETABLISSEMENT_IDENTITE_ABSTRACT',
        'ETABLISSEMENT_ADRESSE_ABSTRACT',
        'ETABLISSEMENT_REPRESENTANT_ABSTRACT',
        'ETABLISSEMENT_GESTIONNAIRES_ABSTRACT',
        'ETABLISSEMENT_JURIDIQUE_ABSTRACT',
        'DEMANDE_ATTESTATION_ABSTRACT',
        'ETABLISSEMENT_ACCIDENT_TRAVAIL_ABSTRACT',
        'ETABLISSEMENT_DOCUMENT_ABSTRACT',
        'ETABLISSEMENT_PAYMENT_ABSTRACT',
        'ABONNEMENT',
        'ETABLISSEMENT_CART_ABSTRACT',
        'ETABLISSEMENT_APPRENTI_ABSTRACT',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_ETABLISSEMENT_ABSTRACT);
    },

    hasItems (): boolean {
      return this.etablissement.id > 0
    },

      canAdd() : boolean {
        return false;
      },

      addLabel() : string {
        return 'Ajouter';
      },

    selectedEtablissement (): Etablissement {
      return this.etablissement
    },

    events (): Record<string, () => void> {
      const event: any = {};
      event["saved"] = () => this.sectionOpen = false;
      event["closeDialog"] = () => this.sectionOpen = false;
      return event;
    },

    currentProperties (): any {
      return {
        extended: true,
        showButton: true,
        autoSave:true,
        readOnly:this.readOnly,
        moduleId: this.moduleId,
        ressourceHeader:this.ressource,
        fiche: this.fiche,
        isAbstract: true,
        etablissement: this.selectedEtablissement,
        route:this.route,
        attribut: this.attribut,
        adresse: this.selectedAdresse,
        owner: this.owner,
      };
    },

    selectedAdresse (): Adresse {
      if (this.etablissement.adresseId == 0) {
        return storeAdresse.createNewAdresse();
      } else {
        return storeAdresse.getAdresse(this.etablissement.adresseId);
      }
    },

    owner (): Owner {
      const owner = new Owner();
      owner.objType =  ObjTypes.ETABLISSEMENT;
      owner.objId = this.etablissement.id;
      return owner;
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    openSection (component: any, route: Route, isList = false): void {
      if (isList) {
        goToModule(this.router, route)
      } else {
         if (component) {
          this.sectionComponent = component;
          this.sectionOpen = true;
        };
      }
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    etablissementUpdated (etablissement: Etablissement) {
    // To implement
    },

      addItem() : void {
        // To implement
      },

      getNewLabel() : string {
        return ""
      },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.etablissement || this.etablissement.id < 0) && value == 'ETABLISSEMENT_IDENTITE_ABSTRACT') {
        this.setExtended(new Extended('ETABLISSEMENT_IDENTITE_ABSTRACT', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
